import { Group, Loader } from "@mantine/core"
import { CityLink } from "@/components/utils"
import { useAPIResource } from "@/hooks"
import { cityAPI } from "@/utils"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerCity({ answer }: IAnswerProps) {
  const { data, isPending } = useAPIResource(cityAPI, { id: answer?.value?.toString() || "" })
  if (!answer?.value) return <NoAnswer />
  if (isPending) return <Loader size="xs" />
  if (!data) return <NoAnswer />

  return (
    <Group gap="xs">
      <CityLink city={data} size="md" />
    </Group>
  )
}
